module.exports = __webpack_public_path__ + "static/check.bfe09f6810a8.png";